import { EmailValidator } from 'commons-validator-js';
import { EMAIL_REGEX } from '@/constants';

export default {
  install (Vue, Validator) {
    Validator.extend('requiredSelect', {
      getMessage: (field, args) => {
        const [name] = args;
        return `${name} bilgisi zorunlu bir alandır`;
      },
      validate: (value, args = ['false']) => {
        const isMultiple = args[1];
        return isMultiple ? !!value.length : !!value.id;
      },
    });
    Validator.extend('required', {
      getMessage: (field, args) => {
        const [name] = args;
        return `${name} bilgisi zorunlu bir alandır`;
      },
      validate: (value) => {
        return (value + '').length;
      },
    });

    Validator.extend('phoneNumber', {
      getMessage: () => 'Girilen telefon numarası geçersizdir',
      validate: (value, args = [9]) => {
        const [length] = args;
        return value.toString().replace(/[^\d]/g, '').length === length;
      },
    });

    Validator.extend('turkishText', {
      getMessage: () => 'Sadece türkçe karakter giriniz',
      validate: (value, args = []) => {
        const [additionalCharacters] = args;
        const regex = new RegExp(`^[a-zA-Z ğüşıiöçĞÜŞİÖÇ${additionalCharacters}]*$`);

        return regex.test(value);
      },
    });

    Validator.extend('name', {
      validate: (value) => {
        const nameRegex = /[a-zA-ZçğıöüşÇĞİÖÜŞ. ]+$/;
        return nameRegex.test(value);
      },
    });

    Validator.extend('password', {
      getMessage: () => 'Şifre en az 8 karakterden oluşmalı, 1 rakam, 1 küçük harf, 1 büyük harf ve 1 özel karakter içermelidir.',
      validate: (value) => {
        const passwordRegex = /((?=.*[a-zçğıöüş])(?=.*\d)(?=.*[A-ZÇĞİÖÜŞ])(?=.*[@#$%!&*.+\-_~]).{8,255})/;
        return passwordRegex.test(value);
      },
    });

    Validator.extend('noSpecialCharacter', {
      validate: (value) => {
        const passwordRegex = /(?=.*[@#$%!&*.+\-_~])/;
        return passwordRegex.test(value);
      },
    });

    Validator.extend('noNumber', {
      validate: (value) => {
        const passwordRegex = /(?=.*\d)/;
        return passwordRegex.test(value);
      },
    });

    Validator.extend('noUpperAndLowerCase', {
      validate: (value) => {
        const passwordRegex = /((?=.*[a-zçğıöüş])(?=.*[A-ZÇĞİÖÜŞ]))/;
        return passwordRegex.test(value);
      },
    });

    Validator.extend('min', {
      validate: (value) => {
        const passwordRegex = /(.{8,255})/;
        return passwordRegex.test(value);
      },
    });

    Validator.extend('minChar', {
      getMessage: (field, args) => {
        const [length, name] = args;
        return `${name} alanı en az ${length} karakterden oluşmalı.`;
      },
      validate: (value, args = [9]) => {
        const [length] = args;
        return value.toString().length > length;
      },
    });

    Validator.extend('textGte', {
      getMessage: (field, args) => {
        const [length, name] = args;
        return `${name} alanı en az ${length} karakterden oluşmalı.`;
      },
      validate: (value, args = [9]) => {
        const [length] = args;
        return value.toString().length >= length;
      },
    });

    Validator.extend('mersisNo', {
      getMessage: 'Mersis No alanı 16 karakterden kısa olamaz.',
      validate: (value) => {
        if (value.length === 0) {
          return true;
        } else if (value.length < 16) {
          return false;
        }
        return true;
      },
    });

    Validator.extend('scEmail', {
      getMessage: () => 'Girilen e-mail geçersizdir.',
      validate: (value) => {
        const re = new RegExp(EMAIL_REGEX);
        const validator = new EmailValidator();

        return validator.isValid(value) && re.test(value);
      },
    });
  },
};
